import React, { useEffect, useRef } from 'react';
import { Addons } from '../../Addons/Addons';

const StickyBar = (props) => {

  return (
    <div className='cellular-jet-sticky-bar'>
      <span className='bar-text'>{props.text}</span>
    </div>
  );
};

export default StickyBar;
